import { isSuperAdmin } from './roleConstants';

export const TEST_COMPANY_NAME = 'test';

export function isTestCompanyName(companyName) {
  return (companyName || '').trim().toLowerCase() === TEST_COMPANY_NAME;
}

/** User Settings is only for superadmin of the test company. */
export function canAccessUserSettings(user) {
  if (!user || !isSuperAdmin(user)) return false;
  return isTestCompanyName(user.companyName);
}
